import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { getApiUrl } from '../../../core/helpers/rest-utils';
import { UserService } from '../../../core/user/user.service';

export interface YelpZapierAccount {
  id: string;
  title: string;
}

export interface YelpZapierBusiness {
  id: string;
  name: string;
}

export interface YelpZapierZap {
  key: string;
  isEnabled: boolean;
  lastSuccessfulRunAt: string | null;
  editorUrl: string | null;
}

export interface YelpZapierSetup {
  zapierConnected: boolean;
  yelpAccounts: YelpZapierAccount[];
  yelpConnectUrl: string | null;
  yelpAuthenticationId: string | null;
  yelpBusinessId: string | null;
  zaps: YelpZapierZap[];
}

@Injectable({
  providedIn: 'root'
})
export class YelpZapierSetupService {
  constructor(private http: HttpClient, private user: UserService) {
  }

  get(): Observable<YelpZapierSetup> {
    return this.http.get(`${getApiUrl()}yelp-zapier-setup`, this.options())
      .pipe(map((res: any) => res.data as YelpZapierSetup));
  }

  authorizationUrl(): Observable<string> {
    return this.http.post(`${getApiUrl()}yelp-zapier-setup/authorization`, {}, this.options())
      .pipe(map((res: any) => res.data?.url as string));
  }

  connect(code: string, state: string): Observable<YelpZapierSetup> {
    return this.http.post(`${getApiUrl()}yelp-zapier-setup/connection`, { code, state }, this.options())
      .pipe(map((res: any) => res.data as YelpZapierSetup));
  }

  disconnect(): Observable<unknown> {
    return this.http.delete(`${getApiUrl()}yelp-zapier-setup/connection`, this.options());
  }

  yelpBusinesses(yelpAuthenticationId: string): Observable<YelpZapierBusiness[]> {
    return this.http.get(`${getApiUrl()}yelp-zapier-setup/yelp-businesses`, {
      ...this.options(),
      params: { yelp_authentication_id: yelpAuthenticationId },
    }).pipe(map((res: any) => (res.data || []) as YelpZapierBusiness[]));
  }

  turnOn(yelpAuthenticationId: string, yelpBusinessId: string | null): Observable<YelpZapierSetup> {
    return this.http.post(`${getApiUrl()}yelp-zapier-setup/zaps`, { yelpAuthenticationId, yelpBusinessId }, this.options())
      .pipe(map((res: any) => res.data as YelpZapierSetup));
  }

  private options(): { headers: { 'X-Business-ID': string } } {
    return { headers: { 'X-Business-ID': this.user.activeBusiness?.id } };
  }
}
